import { css, useTheme } from '@emotion/react';
import { SignInTitle } from '~/components/common';

export interface LayoutProps {
  title?: string;
  gap: number;
  children: React.ReactNode;
}

export default function Layout({ title, gap, children }: LayoutProps) {
  const theme = useTheme();

  return (
    <div
      css={css`
        display: flex;
        position: relative;
        flex-direction: column;
        width: 100%;
        height: 100%;
        padding: ${theme.layout.chat_header_height} 16px 0;
      `}
    >
      {title && <SignInTitle title={title} mb={gap} />}
      {children}
    </div>
  );
}
